<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import {getLogoImg} from "@/api/login.js";
export default {
  data() {
    return {
      icon:"",
      title:"",
    }
  },
  created() {
    this.$theme.changeTheme('#4F8FFD', '#409EFF')
    this.getLogo()
  
  },
  methods: {
    async getLogo(){
      const res = await getLogoImg()
      this.title = res.data.top_title
      this.icon = res.data.terminate_lefttop_logo
      this.changeFavicon(this.icon,this.title);
    },
    changeFavicon(src,title) {
      let link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.getElementsByTagName('head')[0].appendChild(link);
      }
      document.title = title;
      link.href = src;
    }
  },
  mounted() {
    // 调用changeFavicon方法来修改favicon
   
  }
}
</script>

<style>
html,body {
  height: 100%;
  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
}
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
.el-textarea textarea,
pre {
  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
}
.container {
  flex: 1;
  padding: var(--padding-gap);
  overflow: hidden auto;
  display: flex;
  flex-direction: column;
  gap: var(--padding-gap);
}
.card {
  border-radius: var(--card-radius);
  background-color: #FFF;
  padding: 16px 24px;
}
.cardTitle {
  font-size: 15px;
  color: #333;
}
.el-dialog {
    border-radius: 8px !important;
}
.el-dialog .el-dialog__header {
    border-bottom: 1px solid #f2f2f2;
    /* padding: 15px 20px !important; */
}
.el-dialog .el-dialog__body {
    padding: 20px !important;
}
.el-dialog .el-dialog__footer {
    padding: 10px 20px 20px 20px !important;
}
.el-message{min-width: 100px !important;}
.el-table{font-size: 16px !important;}
</style>
